<ng-container *ngIf="popoverConf">
  <ion-grid class="table-row-popover">
    <ion-row>
      <ng-container *ngFor="let item of popoverConf">
        <ion-col [size]="item.colSize" class="table-row-popover__col">
          <div class="table-row-popover__header">{{ item.label.toString() | translate }}</div>
          <div *ngIf="item.value; else noValue">
            <div *ngIf="item.type === 'TEXT_CELL'">{{ item.value }}</div>
            <div *ngIf="item.type === 'DATE_CELL'">{{ item.value | date: 'dd/MM/yyyy' }}</div>
            <div *ngIf="item.type === 'ERROR_CELL'" class="table-row-popover__error">
              {{ item.value.toString() | translate }}
            </div>
          </div>
          <ng-template #noValue>
            <div>--</div>
          </ng-template>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
</ng-container>
